module.exports = __webpack_public_path__ + "static/img/1.233814f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mo/1.png
// module id = xBpU
// module chunks = 0